/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Paid_AnnuallyInputs */

const en_plan_paid_annually = /** @type {(inputs: Plan_Paid_AnnuallyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(paid annually)`)
};

const es_plan_paid_annually = /** @type {(inputs: Plan_Paid_AnnuallyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(pagado anualmente)`)
};

/**
* | output |
* | --- |
* | "(paid annually)" |
*
* @param {Plan_Paid_AnnuallyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_paid_annually = /** @type {((inputs?: Plan_Paid_AnnuallyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Paid_AnnuallyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_paid_annually(inputs)
	return en_plan_paid_annually(inputs)
});